import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Utility from '../../../../../util/utilityfunctions';

const Ellipsis = ({content, lines, width, richText, display, maxWidth, styleName}) => {
	const isSingleLine = lines === 1;

	let displayTitle, displayContent, Component;

	if (richText) {
		displayTitle = Utility.getInnerTextFromRichText(content);
		displayContent = Utility.createRichTextElement(content);
	} else {
		displayTitle = content;
		displayContent = content;
	}

	const props = {
		className: isSingleLine ? `ellipsis-single-line ${styleName}` : `ellipsis-multi-line ${styleName}`,
		title: displayTitle,
		customWidth: width,
		customMaxWidth: maxWidth
	};

	if (isSingleLine) {
		Component = StyledSingleLineEllipsis;
		props.display = display;
	} else {
		Component = StyledMultiLineEllipsis;
		props.lines = lines;
	}

	return <Component {...props}>{displayContent}</Component>;
};

export default Ellipsis;

Ellipsis.defaultProps = {
	lines: 1,
	width: '100%',
	richText: false,
	display: 'inline-block'
};

Ellipsis.propTypes = {
	content: PropTypes.string.isRequired,
	lines: PropTypes.oneOf([1, 2, 3]),
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	richText: PropTypes.bool,
	display: PropTypes.oneOf(['inline', 'inline-block', 'block'])
};

const StyledEllipsis = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	width: ${(props) => (props.customWidth ? `${props.customWidth}` : 'auto')};
	max-width: ${(props) => (props.customMaxWidth ? `${props.customMaxWidth}` : 'none')};
`;

const StyledSingleLineEllipsis = styled(StyledEllipsis)`
	display: ${({display}) => display};
	white-space: nowrap;
	margin-right: 0.5rem;
`;

const StyledMultiLineEllipsis = styled(StyledEllipsis)`
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: ${(props) => props.lines};
	word-wrap: break-word;
	white-space: break-spaces;
`;
